import React from 'react';
import 'Assets/styles/default/pages/concierge/ManageConciergeSolicitationStyles.less';
import { Col, Row } from 'antd';
import { Table, Typography } from '@vertem-core/vertice-ds';
import StatusIcon from 'components/Concierge/Icons/status';
import PropTypes from 'prop-types';

const ManageConciergeDetailsTable = ({ ...props }) => {

    const {
        listConcierge
    } = props;

    const GetStatusColor = (status) => {
        switch (status) {
            case 1:
                return 'var(--color-success)';
            case 2:
                return 'var(--color-yellow)';
            case 3:
                return 'var(--color-neutral-light)';
            case 4:
                return 'var(--color-red)';
        }
    }

    const columns = [
        {
            title: 'Nº da solicitação',
            dataIndex: 'solicitationNumber',
            align: 'center',
            render: (_, { solicitationNumber }) => (
                <div className='text-align-center'>
                    {solicitationNumber ? solicitationNumber : '-'}
                </div>
            ),
        },
        {
            title: 'Data da solicitação',
            dataIndex: 'date',
            align: 'center',
            render: (_, { date }) => (
                <div className='text-align-center'>
                    {
                        date 
                            ? new Date(date).toLocaleString('pt-BR', { dateStyle: "short" }) 
                            : '-'
                    }
                </div>
            ),
        },
        {
            title: 'Solicitante',
            dataIndex: 'requester',
            align: 'center',
            render: (_, { requester }) => (
                <div className='text-align-center'>
                    {requester ? requester : '-'}
                </div>
            ),
        },
        {
            title: 'Participante',
            dataIndex: 'participant',
            align: 'center',
            render: (_, { participant }) => (
                <div className='text-align-center'>
                    {participant ? participant : '-'}
                </div>
            ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            align: 'center',
            render: (_, { status, statusDescription }) => (
                <Row justify={'center'}>
                    <Col>
                        <StatusIcon color={GetStatusColor(status)} />
                    </Col>
                    {
                        statusDescription &&
                        <Col className='text-align-center'>
                            <Typography.Text className='span-cell-content cell-status'>
                                {statusDescription}
                            </Typography.Text>
                        </Col>
                    }
                </Row>
            ),
        }
    ];

    return (
        <>
            <Row>
                <Col span={24} className='margin-top-small'>
                    <Typography.Text className='details-card-title'>
                        Detalhes da Solicitação
                    </Typography.Text>
                </Col>
            </Row>
            <Row className='margin-top-small'>
                <Col span={24} className='container-table-concierge-details'>
                    <Table
                        pagination={false}
                        className='table-concierge'
                        bordered
                        rowKey={(record) => record.id}
                        columns={columns}
                        dataSource={listConcierge}
                        scroll={{ x: "1024px" }}
                    />
                </Col>
            </Row>
        </>
    )
}

ManageConciergeDetailsTable.propTypes = {
    listConcierge: PropTypes.array.isRequired
};

export default ManageConciergeDetailsTable;